import { httpPost, httpPut } from '../http/actions'
import {
  GET_COMPTE_TIERS,
  GET_COMPTE_TIERS_SUCCESS,
  GET_COMPTE_TIERS_FAILURE,
  ADD_COMPTE_TIERS,
  ADD_COMPTE_TIERS_FAILURE,
  ADD_COMPTE_TIERS_SUCCESS,
  UPDATE_COMPTE_TIERS,
  UPDATE_COMPTE_TIERS_SUCCESS,
  UPDATE_COMPTE_TIERS_FAILURE,
  GET_COMPTE_TIERS_LIST_MORE,
  GET_COMPTE_TIERS_LIST_MORE_SUCCESS,
  GET_COMPTE_TIERS_LIST_MORE_FAILURE,
} from './constants'

import { axiosHTTP } from '../../utils'
import { removeNull } from '../../utils/utils'

const polarisApi = process.env.REACT_APP_POLARIS_MS_URL

let CancelToken = axiosHTTP.CancelToken
let cancel
export default (store) => (next) => (action) => {
  if (action.type === GET_COMPTE_TIERS) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }

    const {
      compteTiers: { filter },
    } = store.getState()

    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}third-party-accounts/query`,
        data: removeNull(filter),
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: GET_COMPTE_TIERS_SUCCESS,
        failure: GET_COMPTE_TIERS_FAILURE,
      })
    )
  }

  if (action.type === GET_COMPTE_TIERS_LIST_MORE) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }
    const {
      compteTiers: { filter },
    } = store.getState()

    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}third-party-accounts/query`,
        data: removeNull(filter),
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c
        }),
        success: GET_COMPTE_TIERS_LIST_MORE_SUCCESS,
        failure: GET_COMPTE_TIERS_LIST_MORE_FAILURE,
      })
    )
  }

  if (action.type === ADD_COMPTE_TIERS) {
    const { compteTiers } = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}third-party-accounts`,
        data: compteTiers,
        success: ADD_COMPTE_TIERS_SUCCESS,
        failure: ADD_COMPTE_TIERS_FAILURE,
      })
    )
  }

  if (action.type === UPDATE_COMPTE_TIERS) {
    const { newCompteTiers, id } = action.payload
    store.dispatch(
      httpPut({
        endPoint: `${polarisApi}third-party-accounts/${id}`,
        data: newCompteTiers,
        success: UPDATE_COMPTE_TIERS_SUCCESS,
        failure: UPDATE_COMPTE_TIERS_FAILURE,
      })
    )
  }

  next(action)
}
